<div class="timeline-container">
    <div class="timeline-body">
        <div class="icon-flex">
            <div class="icon-container">
                <img [src]="imageUrl" [alt]="imageAlt" />
            </div>
            <div class="actual-body">
                <h1 class="timeline-title">{{ eventName }}</h1>
                <p class="event-place">{{ applyMethod }}</p>
                <div class="timeline-details">
                    <div class="details-item">
                        <img
                            src="/assets/img/defaultPerson.svg"
                            alt="Assigned Person Icon"
                        />
                        <p>
                            Performed by:
                            <span class="bold-text">{{ assignedTo }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="timeline-status">Day {{ dayNumber }}</div>
</div>
